import React from 'react'

function References() {
  return (
    <div>References</div>
  )
}

export default References